import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center text-center px-6">
      <div>
        <div className="display text-7xl text-gold">404</div>
        <p className="mt-4 text-mute">This page slipped out of stock.</p>
        <Link to="/" className="btn btn-primary mt-6">Back to Souqli</Link>
      </div>
    </div>
  );
}
